import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import WalletConnect from './WalletConnect';
import './Navbar.css';

const links = [
  { to: '/lobby',    label: 'Apex'       },
  { to: '/fortnite', label: 'Fortnite'   },
  { to: '/cs2',      label: 'CS2'        },
  { to: '/tarkov',   label: 'Tarkov'     },
  { to: '/1v1',      label: '⚔️ 1v1'     },
  { to: '/results',     label: 'Results'     },
  { to: '/leaderboard', label: 'Leaderboard' },
  { to: '/blog',        label: 'Blog'        },
  { to: '/profile',  label: 'My Profile' },
];

export default function Navbar({ onConnect, onDisconnect, walletAddress }) {
  const [open, setOpen] = useState(false);

  function getLinkClass({ isActive }) {
    return isActive ? 'navbar__link navbar__link--active' : 'navbar__link';
  }

  return (
    <>
      <nav className="navbar">
        <NavLink to="/" className="navbar__logo" onClick={() => setOpen(false)}>
          <span className="navbar__logo-text">EzEgames</span>
          <span className="navbar__logo-underline" />
        </NavLink>

        <div className="navbar__links">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} className={getLinkClass}>
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="navbar__right">
          <WalletConnect onConnect={onConnect} onDisconnect={onDisconnect} />
          <button
            className="navbar__hamburger"
            onClick={() => setOpen(o => !o)}
            aria-label="Menu"
          >
            <span style={{ transform: open ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
            <span style={{ opacity: open ? 0 : 1 }} />
            <span style={{ transform: open ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
          </button>
        </div>
      </nav>

      <div className={`navbar__drawer${open ? ' open' : ''}`}>
        {links.map(l => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === '/'}
            className={getLinkClass}
            onClick={() => setOpen(false)}
          >
            {l.label}
          </NavLink>
        ))}
      </div>
    </>
  );
}
